import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=1d19169f&scoped=true"
import script from "./addService.vue?vue&type=script&lang=js"
export * from "./addService.vue?vue&type=script&lang=js"
import style0 from "./addService.vue?vue&type=style&index=0&id=1d19169f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19169f",
  null
  
)

export default component.exports